import {
  type FetchDepartmentsAndAislesItemsMeshQueryVariables,
  type FetchDepartmentsAndAislesProductsMeshQueryVariables,
  type InstacartCustomersSharedV1Locale,
} from '__codegen__/api'
import { type FetchAisleProductsWithLocaleParams } from './types'

export const prepareProductVariables: (
  ...args: FetchAisleProductsWithLocaleParams
) => FetchDepartmentsAndAislesProductsMeshQueryVariables = (localeCode, params, query) => {
  const queryVariables: FetchDepartmentsAndAislesProductsMeshQueryVariables = {
    localeCode: localeCode as InstacartCustomersSharedV1Locale,
    retailerId: params.warehouse_id,
    limit: (10).toString(),
    offset: (10 * (query.page - 1)).toString(),
  }

  const departmentId = params.aisle_id ? undefined : params.department_id
  const aisleId = params.aisle_id

  if (query.only_primary_products) {
    queryVariables.primaryDepartmentId = departmentId
    queryVariables.primaryAisleId = aisleId
  } else {
    queryVariables.departmentIds = departmentId ? [departmentId] : undefined
    queryVariables.aisleIds = aisleId ? [aisleId] : undefined
  }

  return queryVariables
}

export const prepareItemVariables: (
  ...args: FetchAisleProductsWithLocaleParams
) => FetchDepartmentsAndAislesItemsMeshQueryVariables = (localeCode, params, query) => {
  const queryVariables: FetchDepartmentsAndAislesItemsMeshQueryVariables = {
    localeCode: localeCode as InstacartCustomersSharedV1Locale,
    retailerId: params.warehouse_id,
    limit: (10).toString(),
    offset: (10 * (query.page - 1)).toString(),
  }

  const departmentId = params.aisle_id ? undefined : params.department_id
  const aisleId = params.aisle_id
  const inventoryAreaId = query.inventory_area_ids.toString()

  if (query.only_primary_products) {
    queryVariables.primaryDepartmentId = departmentId
    queryVariables.primaryAisleId = aisleId
  } else {
    queryVariables.departmentIds = departmentId ? [departmentId] : undefined
    queryVariables.aisleIds = aisleId ? [aisleId] : undefined
  }
  queryVariables.inventoryAreaId = inventoryAreaId

  return queryVariables
}
